import { ArticleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Paper = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ArticleIcon {...rest} size={Sizes[size]} color={fill} />;
};

Paper.displayName = 'Paper';
